import * as yup from 'yup';
const validation = {
  Login: yup.object({
    password: yup.string().required('Password is required.'),
    emailAddress: yup.string().required('Email address is required.'),
  }),
};

export default validation;
